import enLocale from 'element-ui/lib/locale/lang/en'
import HzmbG_EN from './service/HzmbG_EN';
import { PT } from "./PT";
const EN = {
  message: {
    ...PT.message,
    lang: 'EN',
    lang_account: 'en',
    lan: 'En',
    lans: 'En',
    codeName: 'codePname',
    doc_title: 'Transport Bureau Online services',
    copyRight: 'This webpage is best viewed on IE Edge+/Chrome/Firefox/Safari browsers with a resolution of 1024x768 pixels or higher to achieve optimal browsing experience',
    termsTitle: 'Terms and conditions',
    agree: 'agree',
    disagree: 'disagree',
    before_filling: 'Before filling out the application, you need to prepare in advance',
    ready_to_filling: 'Ready, start filling in the information',
    view_sample: 'View sample',
    verify_submit: 'Submit verification',
    guide: 'User Guide',
    download: 'Download',
    guide_title12: 'Parking of Hong Kong Goods Vehicles at the Macao Cross-Border Cargo Transfer Terminal - New Application',
    guide_title13: 'Parking of Hong Kong Goods Vehicles at the Macao Cross-Border Cargo Transfer Terminal - Submit Insurance Information',
    close: 'Close',
    get_phone_code: 'get verification code',
    second: ' seconds',
    select_file: 'Select a document',
    reupload: 'Re-upload',
    back: 'back',
    support_files_part1: 'Supports uploading in ',
    support_files_part2: ' formats, with a maximum file size of 5MB',
    confirm_submit_content: 'Confirm submission?',
    form_error: ' "Error in field entries, please check!',
    tips: 'Alert',
    confirm: 'Confirm',
    cancel: 'Cancel',
    tempSave_tips: "Save and next step",
    router: {
      formData: 'Fill in information',
      upload: 'upload files',
      check: 'Check and confirm'
    },
    Verification: {
      phone_code: 'Mobile phone verification code',
      phone_code_placeholder: 'Please enter the mobile verification code',
      mobile_placeholder: 'Please enter your Macau mobile phone number',
    },
    formRuleMessage: {
      notNull: 'Can not be empty',
      macauMobile: 'Please enter the correct mobile phone number',
      olderThan18: 'Driver must be over 18 years old',
      email: 'Please enter a correct email address',
    },
    DataRegistration: {
      formData: {
        add_drivers: 'Add new driver',
        next: 'Next step: Upload files',
      },
      upload: {
        already_upload_file: 'Files uploaded: ',
        next: 'Next step: Check and confirm',
      },
      check: {
        already_upload_file: 'Files uploaded:',
        submit: 'Confirm and submit'
      },
    },
    ErrorMessage: {
      ACCESS_DENIED: 'Access denied',
      REQUEST_TOO_FREQUENTLY: 'The request is too frequent, try again in one minute',
      CAPTCHA_HAS_EXPIRED: 'The verification code has expired, please obtain it again',
      CAPTCHA_VERIFY_FAILED: 'Verification code verification failed, please obtain again!',
      CAPTCHA_NOT_FOUND: 'The verification code does not exist, please obtain it again',
      CAPTCHA_IS_MISMATCH: 'Verification code error!',
      MOBILE_MISMATCH: "(PAS-0001) Mobile phone number does not match, please obtain verification code again",
      GATEWAY_TIME_OUT: 'Request timed out, please try again',
      SYSTEM_BUSY: 'The system is busy or abnormal, please try again later.',
      DOWNLOAD_ERROR: 'Error in downloading files!',
      DUPLICATE_APPROVING_APPLICATION: "Service for Hong Kong vehicle registration number provided by you is being processed",
      CHECK_FAIL: "Falha no acesso",
      "E-1077": "The relevant approval of the Hong Kong vehicle registration number provided by you has expired",
      "E-1001": "The inquiry number does not match the applicant's data",
      "E-H001": "Required parameters cannot be empty",
      "E-H012": "No valid approval document found",
      "E-H023": "This approval already has a temporary status extension or cancellation application",
      "E-H013": "Applicant information is inconsistent",
      // G類保險更新
      UPLOAD_ERROR: "(PAS-0007) Error in uploading files",
      IOException: "(PAS-0008) Error in downloading files",
      CHECK_INSURANCE_UPD_FOR_G_ERROR: "Error in insurance access",
      USER_MOBILE_IS_NULL: "User's mobile phone number is null",
      APPLICATION_STATUS_ERROR: "Application status is abnormal",
      MOBILE_IS_NULL: "Mobile phone number is null",
      REGISTER_TYPE_MAPPING_ERROR: "Registration type matching failed",
    },
    capitalLetter: ['Zero', 'First', 'Second', 'Third'],
  },
  ...HzmbG_EN,
  ...enLocale,
}
export default EN